import React from "react";
import MobileNavbar from "../../MobileNavbar/MobileNavbar";
import Navbar from "../../Navbar/Navbar";
import styles from "./hero.module.scss";
// import img_1 from '../../../assets/banner-lg-carestream-medical.jpg'
import img_1 from '../../../assets/new-banners/all_products_banner_2.jpg'
// import img_2 from '../../../assets/New folder/Healthcare.jpg'
import img_2 from '../../../assets/new-banners/healthcare_product_banner.jpg'
// import img_3 from '../../../assets/New folder/Commercial.jpg'
import img_3 from '../../../assets/new-banners/commercial_banner.jpg'

const Hero = ({Healthcare=false , Commercial=false}) => {
  return (
    <section className={styles.hero_mainContainer}
      mob={Healthcare?'Healthcare':Commercial?'Commercial' :'all'}
      style={{backgroundImage: `url(${Healthcare?img_2:Commercial?img_3 :img_1})`}}>
      <Navbar />
      <MobileNavbar />
      <div className={styles.hero_container}>
        <div className={styles.hero_content_container}>
          <h1 className={styles.hero_heading}>{Healthcare? 'Healthcare - Products' :Commercial?'Commercial - Products': 'Products' }</h1>
        </div>
      </div>
    </section>
  );
};

export default Hero;
